    <div class="container-fluid page-content">

        <div class="row justify-content-center align-items-center mb-1" style="width: 100%; margin-right: 0px;margin-left: 0px;">
            <div class="col-lg-5 col-md-5 col-sm-3 col-3">
                <label class="title">Cargas</label>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-9 col-9 justify-content-end align-items-end text-end">
                <span class="badge text-bg-success" style="padding: 9px; margin-right: 4px; font-size: 13px;" [matTooltip]="'Ultimo cambio: ' + getPrecioActual('MAGNA', 'FECHA') "> 
                    Magna: {{ getPrecioActual('MAGNA', 'PRECIO') | currency : 'MXN'   }}  
                </span>
                <span class="badge text-bg-danger" style="padding: 9px;margin-right: 4px;font-size: 13px;" [matTooltip]="'Ultimo cambio: ' + getPrecioActual('PREMIUM', 'FECHA')"> 
                    Premium: {{ getPrecioActual('PREMIUM', 'PRECIO') | currency : 'MXN'   }}  
                </span>
                <span class="badge text-bg-dark" style="padding: 9px;margin-right: 4px;font-size: 13px;" [matTooltip]="'Ultimo cambio: ' + getPrecioActual('DIESEL', 'FECHA')"> 
                    Diesel: {{ getPrecioActual('DIESEL', 'PRECIO') | currency : 'MXN'   }}  
                </span>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12 col-12 justify-content-end align-items-end text-end">
                <div class="btn-group side-space">
                    <button type="button" class="btn btn-link rounded-button dropdown-toggle" role="menu" id="dropdownOpciones" data-bs-toggle="dropdown" aria-expanded="false">
                        Más opciones
                    </button>
                    <div class="dropdown-menu" style="margin-right: 100px; width: 250px;" aria-labelledby="dropdownOpciones">
                        <button (click)="abrirModalCrearCarga()" style="width: 220px; " class="mt-1 btn btn-sm btn-success rounded-button side-space">
                            <i class="fas fa-plus"></i>&nbsp;
                            Nueva Carga
                        </button>
                        <button (click)="abrirModalPreciosCombustibles()" style="width: 220px; " class="mt-1 btn btn-sm my-button-blue-primary rounded-button side-space">
                            <i class="fas fa-money-bill-transfer"></i>&nbsp;
                            Precios Combustible
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!--Busqueda-->
        <div class="card mt-1" style="border-radius: 12px;">
            <div class="card-body" style="padding-top: 18px; padding-bottom: 18px;">
                <form #formSearchCargas="ngForm" (ngSubmit)="BuscarCargas();">
                    <div class="row justify-content-center align-items-center" style="width: 100%; margin-right: 0px;margin-left: 0px;">
                        <div class="col col-lg-3 col-md-3 col-sm-12 col-12">
                            <div class="form-group">
                                <label class="mb-2"> Estaci&oacute;n </label>
                                <br>
                                <p-dropdown [disabled]="!isAdmin" name="slcEstaciones" (onChange)="updateListEquipos($event)" #slcEstaciones="ngModel" [options]="estaciones" [filter]="true" filterBy="label" [style]="{'width':'100%', 'height': '31px'}" [showClear]="true" placeholder="Todas las estaciones"
                                    [(ngModel)]="SearchCargaRQ.estacion" styleClass="custom-input" optionValue="value" optionLabel="label">

                                </p-dropdown>
                            </div>
                        </div>
                        <div class="col col-lg-3 col-md-3 col-sm-12 col-12">
                            <div class="form-group">
                                <label class="mb-2">N&uacute;mero Econ&oacute;mico </label>
                                <br>
                                <p-dropdown name="slcEquipos" #slcEquipos="ngModel" [options]="equipos" [filter]="true" filterBy="label" [style]="{'width':'100%'}" [showClear]="true" placeholder="Todos los equipos" styleClass="custom-input" [(ngModel)]="SearchCargaRQ.activo" optionLabel="label"
                                    optionValue="value"></p-dropdown>
                            </div>
                        </div>
                        <div class="col col-lg-2 col-md-2 col-sm-12 col-12">
                            <div class="form-group">
                                <label class="mb-2"> Fecha Inicio </label>
                                <br>
                                <p-calendar dateFormat="dd/mm/yy" [readonlyInput]="true" [maxDate]="maxDate" appendTo="body" appendTo="body" inputStyleClass="custom-input" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" name="FechaInicio" #FechaInicio="ngModel" placeholder="Desde"
                                    [(ngModel)]="SearchCargaRQ.initDate">
                                </p-calendar>
                            </div>
                        </div>
                        <div class="col col-lg-2 col-md-2 col-sm-12 col-12">
                            <div class="form-group">
                                <label class="mb-2"> Fecha Fin </label>
                                <br>
                                <p-calendar dateFormat="dd/mm/yy" [readonlyInput]="true" [maxDate]="maxDate" appendTo="body" appendTo="body" inputStyleClass="custom-input" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" name="FechaInicio" #FechaInicio="ngModel" placeholder="Desde"
                                    [(ngModel)]="SearchCargaRQ.endDate">
                                </p-calendar>
                            </div>
                        </div>
                        <div class="col col-lg-2 col-md-2 col-sm-12 col-12 text-center justify-content-center align-items-center">
                            <div class="form-group">
                                <button style="margin-top: 29px; width: 100%;" class="btn my-button-blue-outline btn-sm btn-block rounded-button">
                                    <i class="fas fa-search"></i>&nbsp;Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row mt-3" style="width:100% ; margin-right: 0px;margin-left: 0px;">
            <p-table #dt [value]="lista" [scrollable]="true" [scrollHeight]="'calc(100vh - 340px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="IATA" class="medium-col" style="border-top-left-radius: 15px;"> Estación</th>
                        <th pSortableColumn="cargaEstacion" class="medium-col">Folio</th>
                        <th pSortableColumn="clave" class="medium-col">Compañía</th>
                        <th pSortableColumn="numeroActivo" class="medium-col">Número Económico</th>
                        <th pSortableColumn="fechaCreacion" class="medium-col">Fecha de Carga</th>
                        <th pSortableColumn="horometro" class="medium-col">Horómetro</th>
                        <th pSortableColumn="litrosCarga" class="medium-col">Litros Cargados</th>
                        <th pSortableColumn="combustibleCargado" class="medium-col">Tipo de Combustible</th>
                        <th pSortableColumn="estatus" class="medium-col">Estatus</th>
                        <th class="medium-col" style="border-top-right-radius: 15px;">Acción</th>
                    </tr>

                    <tr class="filter-row">
                        <th>
                            <input placeholder="Filtrar" type="text" #filtroEstacion class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroEstacion.value, 'IATA', 'contains')">
                        </th>

                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroFolio type="text" class="form-input form-input-table-filter medium-col" (input)="dt.filter(filtroFolio.value, 'cargaEstacion', 'contains')">

                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroCompania type="text" class="form-input form-input-table-filter medium-col" (input)="dt.filter(filtroCompania.value, 'clave', 'contains')">
                        </th>

                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroActivo type="text" class="form-input form-input-table-filter medium-col" (input)="dt.filter(filtroActivo.value, 'numeroActivo', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroFechaCarga type="text" class="form-input form-input-table-filter medium-col" (input)="dt.filter(filtroFechaCarga.value, 'fechaCreacion', 'contains')">

                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroHorometro type="text" class="form-input form-input-table-filter medium-col" (input)="dt.filter(filtroHorometro.value, 'horometro', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroLitrosCarga type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroLitrosCarga.value, 'litrosCarga', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroCombustible type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroCombustible.value, 'combustibleCargado', 'contains')">
                        </th>
                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroEstatus type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroEstatus.value, 'estatus', 'contains')">
                        </th>

                        <th></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" class="animated fadeIn fast" let-carga>
                    <tr>
                        <td class="medium-col">{{ carga.IATA }}</td>
                        <td class="medium-col">{{carga.cargaEstacion}}</td>
                        <td class="medium-col">{{carga.clave}}</td>
                        <td class="medium-col">{{carga.numeroActivo}}</td>
                        <td class="medium-col">{{carga.fechaCreacion | date: 'yyyy-MM-dd' }}</td>
                        <td class="medium-col">{{carga.horometro}}</td>
                        <td class="medium-col">{{carga.litrosCarga}}</td>
                        <td class="medium-col">{{carga.combustibleCargado}}</td>
                        <td class="medium-col">{{carga.estatus}}</td>
                        <td class="medium-col">
                            <button type="button" (click)="abrirModalDetallesCarga(carga)" style="font-size:12px; width: 80px;" class="btn btn-xs my-button-blue-outline rounded-button">
                                <i class="fas fa-eye"></i>&nbsp;Detalles
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>